import {
  ActionButtons,
  Button,
  FormHelpText,
  Heading,
  Modal,
  Stack,
  TextField,
} from '@drycut/ui-components';
import { useState } from 'react';

type StylistConfirmationModalProps = {
  invalidCode: boolean;
  onClose: () => void;
  onConfirm: (code: string) => void;
  open: boolean;
};

export function StylistPassConfirmation({
  open,
  invalidCode,
  onClose,
  onConfirm,
}: StylistConfirmationModalProps) {
  const [code, setCode] = useState('');

  const handleConfirm = () => {
    onConfirm(code);
    setCode(''); // Clear the code after confirmation
  };

  return (
    <Modal open={open} onClose={onClose} title={<Heading variant="h2">Zahlungbestätigung</Heading>}>
      <Stack className="gap-5 max-w-full md:max-w-lg items-center">
        <p>
          Bitte kontaktiere einen unserer Stylisten, um die Zahlung durchzuführen und diese zu
          bestätigen zu lassen. Danach erhälst Du umgehend Deinen DRYPASS Code auf die von Dir
          angegebene Telefonnummer. Danke!
        </p>

        <Stack gap={1} className="items-center relative">
          <TextField
            name="code"
            placeholder="Code (Eingabe Stylist)"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            invalid={invalidCode}
            type="password"
          />
          {invalidCode && <FormHelpText error={invalidCode}>Ungültig Code</FormHelpText>}
        </Stack>

        <ActionButtons className="mt-3">
          <Button onClick={handleConfirm}>Bestätigen</Button>

          <Button onClick={onClose} fill="outlined">
            Cancel
          </Button>
        </ActionButtons>
      </Stack>
    </Modal>
  );
}
